import Glide from "@glidejs/glide";
let glide = null;

function initTestimonialSlider(id) {
	glide = new Glide("#" + id, {
		type: "slider",
		rewind: true,
		startAt: 0,
		gap: 20,
		perView: 1,
		breakpoints: {
			900: {
				perView: 1,
				gap: 10,
			},
		},
	});

	glide.mount();
}

export function moveGlide(whichWay) {
	glide.go(whichWay);
}
let cursor = document.querySelector("#cursor");

let testimonial = document.querySelector(".testimonial");

if (testimonial) {
	testimonial.addEventListener("mouseenter", (e) => {
		cursor.classList.add("pale-green");
	});

	testimonial.addEventListener("mouseleave", (e) => {
		cursor.classList.remove("pale-green");
	});
}

window.initTestimonialSlider = initTestimonialSlider;
